import { getService } from "../../axios/services";

// `queryParams` is expected to already be shaped for the endpoint (see buildContentSearchParams).
export const searchContents = (queryParams, { cancelToken } = {}) =>
  getService({
    endpoint: "ContentSearch",
    api: "v2",
    params: queryParams,
    options: { cancelToken },
  });
